"use strict";

// ---------------------------------------------------
// Local Vars

var isBrowser = (typeof window !== "undefined");
var assert = require('bunsen/helpers/assert');

// ---------------------------------------------------
// Dependencies

var $;
var simplyDeferred;

if (isBrowser) {
    try {
        $ = require('dibs-jquery-shim');
    } catch (ignore) {
        // do nothing
    }
}

if (!$ || !$.Deferred) {
    try {
        simplyDeferred = require('simply-deferred');
    } catch (ignore) {
        // do nothing
    }
}

// ---------------------------------------------------
// Module Definition

/**
 * Returns the Deferred implementations.
 * If on the browser, returns jQuery.Deferred. If
 * on a node environment or jQuery.Deferred is not
 * available, returns simply-deferred 'Deferred'.
 * @module getDeferredMethods
 * @type {function}
 * @returns {{ Deferred: function, when: function }}
 */
module.exports = function () {
    if ($ && $.Deferred) {
        return {
            Deferred: $.Deferred,
            when: $.when
        };
    }
    assert(!!simplyDeferred, 'If jQuery and jQuery.Deferred is not present, simply-deferred module is required');
    return {
        Deferred: simplyDeferred.Deferred,
        when: simplyDeferred.when
    };
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/getDeferredMethods.js
// module id = 299
// module chunks = 63